import React from 'react'
import PropTypes from 'prop-types'
import StyledContent from '../styled/pro-content'
// import Icon from "./icon"

const ProContent = ({ title, description, children }) => {
  return (
    <StyledContent>
      {title && <strong className="title">{title}</strong>}
      <div className="description">{description || children}</div>
    </StyledContent>
  )
}

ProContent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape,
  ]),
}

ProContent.defaultProps = {
  title: undefined,
  description: undefined,
  children: undefined,
}
export default ProContent
